export const FILE_ACCEPT = '.pdf,.png,.jpg,.jpeg';
export const MAX_FILE_SIZE = 10000000;

export function fileError(file) {
    if (!/\.(pdf|png|jpe?g)$/i.test(file.name)) return 'Formato non supportato. Usa PDF, PNG o JPEG.';
    if (!file.size) return 'Il file è vuoto.';
    if (file.size >= MAX_FILE_SIZE) return 'Il file deve essere inferiore a 10 MB.';
    return '';
}

export function addFiles(entries, files) {
    const keys = new Set(entries.map(entry => entry.key));
    const result = [...entries];
    for (const file of Array.from(files || [])) {
        const key = JSON.stringify([file.name, file.size, file.lastModified]);
        if (keys.has(key)) continue;
        keys.add(key);
        const error = fileError(file);
        result.push({ key, file, status: error ? 'invalid' : 'pending', error, progress: 0 });
    }
    return result;
}

export function canUpload(entry) {
    return entry.status === 'pending' || entry.status === 'error';
}

export function uploadForm(file, context) {
    const form = new FormData();
    form.append('file', file);
    form.append('articolo', context.articolo);
    form.append('fase', context.fase || '');
    for (const [name, value] of [['operazione', context.operazione], ['distinta_alternativa', context.distintaAlternativa]]) {
        if (value !== null && value !== undefined) form.append(name, value);
    }
    form.append('imballaggio', context.imballaggio ? '1' : '0');
    return form;
}

export async function uploadEntries(entries, { work, context, onUploaded, isActive = () => true }) {
    const destination = { ...context };
    for (const entry of entries.filter(canUpload)) {
        if (!isActive()) break;
        entry.status = 'uploading';
        entry.error = '';
        entry.progress = 0;
        let response;
        try {
            response = await work.post('arts/uploadpicture/', uploadForm(entry.file, destination), true,
                { 'Content-Type': 'multipart/form-data' }, {
                    onUploadProgress(event) {
                        if (event.total) entry.progress = Math.min(100, Math.round(event.loaded / event.total * 100));
                    },
                });
        } catch (error) {
            // A timeout or server failure can occur after the file was saved: never resend automatically.
            const status = error.response?.status;
            const rejected = [400, 401, 403, 413, 415, 422, 429].includes(status);
            entry.status = rejected ? 'error' : 'uncertain';
            entry.error = rejected
                ? (status === 403 ? 'Non hai il permesso di caricare questo file.' : 'Caricamento rifiutato. Controlla il file prima di riprovare.')
                : 'Esito non verificato. Chiudi e aggiorna i disegni prima di un nuovo caricamento.';
            continue;
        }
        if (!response?.data?.code || response.data.res === 'ko') {
            entry.status = 'uncertain';
            entry.error = 'Conferma del salvataggio mancante. Chiudi e aggiorna i disegni prima di riprovare.';
            continue;
        }
        entry.status = 'success';
        entry.progress = 100;
        if (isActive()) onUploaded({
            code: response.data.code,
            name: response.data.name || entry.file.name,
            ext: (response.data.ext || entry.file.name.split('.').pop()).replace(/^\./, '').toLowerCase(),
            imballaggio: destination.imballaggio,
        });
    }
}
